import {
  // Button,
  CardAuthor,
  CardReactions,
  MediaQueries,
  PostContent,
  // theme,
  // ThemeProps,
} from '@hhgtech/hhg-components'
import styled from 'styled-components'

import { CardAuthorWrapper } from '../cardAuthorWrapper'
import { SeeMore } from '../seeMore'

export const StyledInputCommentBarWrapper = styled.div`
  margin-top: 16px;
`

export const StyledInputEditCommentBarWrapper = styled.div`
  margin-bottom: 24px;
`

export const StyledCardAuthorWrapper = styled(CardAuthorWrapper)`
  margin-bottom: 10px;

  ${MediaQueries.mbUp} {
    margin-bottom: 8px;
  }
`
export const StyledCardAuthor = styled(CardAuthor)`
  padding: 0;
`
export const StyledPostContent = styled(PostContent)`
  padding: 0;
`
export const StyledSocialPreview = styled.div`
  margin-bottom: 16px;

  &:empty {
    margin-bottom: 0;
  }
`
export const StyledCardReactions = styled(CardReactions)``
export const StyledCardReplyChild = styled.div`
  padding-top: 16px;
`
export const StyledMoreLink = styled(SeeMore)``
export const StyledCardPostInner = styled.div``
export const StyledCardPost = styled.div`
  position: relative;
  background: white;
  padding-bottom: 30px;
  &:last-child {
    padding-bottom: 0;
  }

  ${StyledPostContent} {
    padding-bottom: 10px;
  }

  ${MediaQueries.mbUp} {
    ${StyledPostContent},
    ${StyledCardReactions},
    ${StyledSocialPreview},
    ${StyledMoreLink} {
      // padding-left: 48px;
    }
  }

  &[data-is-mini-style='true'] {
    ${StyledPostContent},
    ${StyledCardReactions},
    ${StyledSocialPreview} {
      // padding-left: 40px;

      ${MediaQueries.mbUp} {
        padding-left: 40px;
      }
    }
    .author-avatar-wrapper {
      width: 32px;
      height: 32px;
    }
    ${MediaQueries.mbUp} {
      position: relative;
      margin-left: 48px;
    }
    ${StyledCardAuthor} {
      .author-info {
        margin-left: 16px;
      }
    }
  }
`
